import {PlanSimulation_Target} from "@/pb/api/devplan/types/tasks";
import {GetRepoResearchRequest, GetRepoResearchGuidanceRequest} from "@/pb/api/devplan/services/web/company";

export function planTargetKey(target: PlanSimulation_Target): string {
  return `${target.type}:${target.id}`
}

export function getRepoResearchKey(req: GetRepoResearchRequest): string {
  const {dirKey, repoId, provider} = req
  return `${provider}:${repoId}:${dirKey}`
}

export function getRepoGuidanceKey(req: GetRepoResearchGuidanceRequest): string {
  const {repoId, provider} = req
  return `guidance:${provider}:${repoId}`
}